import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

interface AuditPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const AuditPagination: React.FC<AuditPaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  return (
    <Pagination>
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink first onClick={() => onPageChange(1)} />
      </PaginationItem>
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink
          previous
          onClick={() => onPageChange(currentPage - 1)}
        />
      </PaginationItem>
      {Array.from({ length: totalPages }, (_, index) => index + 1).map(
        (page) => (
          <PaginationItem active={page === currentPage} key={page}>
            <PaginationLink onClick={() => onPageChange(page)}>
              {page}
            </PaginationLink>
          </PaginationItem>
        )
      )}
      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink next onClick={() => onPageChange(currentPage + 1)} />
      </PaginationItem>
      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink last onClick={() => onPageChange(totalPages)} />
      </PaginationItem>
    </Pagination>
  );
};
